export default __webpack_public_path__ + "static/media/JournalBook2.bd3cb0ba.svg";